const hamburger = document.querySelector('.p-header-burger');
const navMenu = document.querySelector('.p-header-nav');
const closeBtn = document.querySelector('.c-btn-close');
const bglayer = document.querySelector('.p-header-bg-opacity');
const headerNavLink = document.querySelector('.p-header-nav__link');
// 親メニューのhover要素 PC
const parentMenuItemPc = document.querySelectorAll('.js-menu-haschild-pc');
// 親メニューのhover要素 SP
const parentMenuItemSp = document.querySelectorAll('.js-menu-haschild-sp');
let menuClose = true;
let gap;

/**
 * matchMedia
 */

const mediaQueryList = window.matchMedia('(min-width: 768px)');
const listener = (event) => {
  resizeInit();
  // リサイズ時に行う処理
  if (event.matches) {
    // PC用
    gap = 0;
    for (let i = 0; i < parentMenuItemPc.length; i++) {
      parentMenuItemPc[i].addEventListener('mouseover', dropDownMenuOpen);
      parentMenuItemPc[i].addEventListener('mouseleave', dropDownMenuClose);
    }
    // SP用の eventlisterをremove
    for (let i = 0; i < parentMenuItemSp.length; i++) {
      parentMenuItemSp[i].removeEventListener('click', toggleMenu);
    }
  } else {
    // SP用
    gap = 77;
    for (let i = 0; i < parentMenuItemSp.length; i++) {
      parentMenuItemSp[i].addEventListener('click', toggleMenu);
    }
    const stoppropagate = document.querySelectorAll('.p-header-nav__second-link');
    for (let i = 0; i < stoppropagate.length; i++) {
      stoppropagate[i].addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
    // PC用の eventlisterをremove
    for (let i = 0; i < parentMenuItemPc.length; i++) {
      parentMenuItemPc[i].removeEventListener('mouseover', dropDownMenuOpen);
      parentMenuItemPc[i].removeEventListener('mouseleave', dropDownMenuClose);
    }
  }
};

// リスナー登録
mediaQueryList.addEventListener('change', listener);
// 初期化処理
listener(mediaQueryList);

// PC ドロップダウンメニューを開く処理
function dropDownMenuOpen(e) {
  // e.preventDefault();
  // 子メニューa要素
  const childMenuLinkPc = e.currentTarget.querySelectorAll('.p-header-nav__second-link');

  // is-activeを付加
  for (let i = 0; i < childMenuLinkPc.length; i++) {
    childMenuLinkPc[i].classList.add('is-active');
  }
}

// PC ドロップダウンメニューを閉じる処理 PC
function dropDownMenuClose(e) {
  // 子メニューリンク
  const childMenuLinkPc = e.currentTarget.querySelectorAll('.p-header-nav__second-link');

  // is-activeを削除
  for (let i = 0; i < childMenuLinkPc.length; i++) {
    childMenuLinkPc[i].classList.remove('is-active');
  }
}

// SP トドロップダウンメニューをtoggle処理
function toggleMenu() {
  const parentMenuLinkSp = event.currentTarget.querySelectorAll('.p-header-nav__link');
  for (let i = 0; i < parentMenuLinkSp.length; i++) {
    parentMenuLinkSp[i].classList.toggle('active');
  }
  const childMenuLinkSp = event.currentTarget.querySelectorAll('.p-header-nav__second-link');
  event.preventDefault();
  for (let i = 0; i < childMenuLinkSp.length; i++) {
    childMenuLinkSp[i].classList.toggle('is-active');
  }
}

// リサイズ時に行う初期化処理（windowサイズの再代入など）
function resizeInit() {
  spMenuClose();
  const childMenuLink = document.querySelectorAll('.p-header-nav__second-link');
  // console.log(childMenuLink);
  for (let i = 0; i < childMenuLink.length; i++) {
    // 子メニュー
    childMenuLink[i].classList.remove('is-active');
  }
  const parentMenuLinkSp = document.querySelectorAll('.p-header-nav__link');
  for (let i = 0; i < parentMenuLinkSp.length; i++) {
    parentMenuLinkSp[i].classList.remove('active');
  }
}

// load all events
allEventListners();

// humburger
function spMenuOpen() {
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  hamburger.classList.add('is-active');
  navMenu.classList.add('is-open');
  bglayer.classList.add('is-show');
  document.querySelector('body').dataset.top = scrollTop;
  document.querySelector('body').classList.add('fixed');
  document.querySelector('body').style.top = -scrollTop + 'px';
}

function spMenuClose() {
  var scrollPos = document.querySelector('body').dataset.top;
  hamburger.classList.remove('is-active');
  navMenu.classList.remove('is-open');
  bglayer.classList.remove('is-show');
  document.querySelector('body').classList.remove('fixed');
  document.querySelector('body').style.top = '';
  window.scrollTo({ top: scrollPos, behavior: 'instant' });
  menuClose = true;
}

function allEventListners() {
  hamburger.addEventListener('click', (event) => {
    event.preventDefault();
    if (menuClose) {
      menuClose = false;
      spMenuOpen();
      // console.log(menuClose);
    } else {
      menuClose = true;
      spMenuClose();
      // console.log(menuClose);
    }
  });
  closeBtn.addEventListener('click', closeBtnClick);
}

// closeBtn function
function closeBtnClick(event) {
  if (navMenu.classList.contains('is-open')) {
    hamburger.click();
    event.preventDefault();
  }
}

// 追従バナー
window.addEventListener('scroll', () => {
  const floatBanner = document.getElementById('js-floating-banner');
  const docHeight = document.body.clientHeight;
  const scrollCount = document.documentElement.scrollTop || document.body.scrollTop;
  const scrollPos = document.documentElement.clientHeight + scrollCount;
  const footerHeight = document.getElementById('footer').clientHeight;
  if (700 >= scrollCount) {
    setTimeout(function () {
      floatBanner.classList.add('is-hide');
    }, 1);
  } else {
    floatBanner.classList.remove('is-hide');
    floatBanner.style.position = 'fixed';
    floatBanner.style.bottom = 0 + 'px';
  }
});

//page anchor
const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

for (let i = 0; i < smoothScrollTrigger.length; i++) {
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    gap;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
}
